module.exports = __webpack_public_path__ + "img/tema-1-11.e992b645.png";